<div class="contextmenu">
  <app-node-actions
    class="contextmenu__node-actions"
    eventCategory="Context Node"
    [ngStyle]="getNodeActionsStyles()"
    [node]="node"
    (nodeActionsClosed)="onNodeActionsClosed()"
    theme="light">
  </app-node-actions>
</div>